$(function() {

	// FAQ accordion
	if ( $('.faqs-accordion').length != 0 ) {
		$('.faqs-accordion .faqs-title').on('click', function(){
			$(this).parent('.faqs-item').toggleClass('active').siblings().removeClass('active').find('.faqs-content').slideUp(200);
			$(this).siblings('.faqs-content').slideToggle(200);
		});

		// 預設第一個展開
		$('.faqs-accordion .faqs-item').eq(0).addClass('active').find('.faqs-content').css('display', 'block');
	}

});